import React, {useEffect, useState} from "react";
import service from './service';

const Whos = () => {

  const [whos, setWhos] = useState([]);

  useEffect(() =>
    service.findAllWhos()
    .then(whos => setWhos(whos)));

  return(
    <div>
      <ul className="list-group">
        {
          whos.map(who =>
            <div className={`list-group-item`}>
              <div className={`container-fluid`}>
                <div className={`row style=display: flex`}>
                  <div className={`col-xxl-auto col-xl-auto col-lg-2 `}>
                    <img className={'rounded-circle'}
                         alt={'avatar'}
                         src={who.avatarIcon}
                         width="50"/>
                  </div>
                  <div className={`col-xxl-4 col-xl-4 col-lg-4 ms-lg-3  text-white text-nowrap`}>
                    <div className={`row`}>
                      <div className={`col-auto`}>
                        <a href={'#top'}>${who.userName}</a>
                        <i className={`fas fa-check-circle`}></i>
                      </div>
                    </div>
                    <div className={`row`}>
                      <div className={`col-auto`}>
                        <a href={'#top'}>@{who.handle}</a>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`col-lg-3 col-xl-3 col-xxl-3 justify-content-end  text-white`}>
                    <div className={`ms-xl-5 ms-xxl-5 mr-3`}>
                      <button className={`btn btn-primary me-md-2 rounded-pill type=button
                    style=display: flex`}>Follow
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        }
      </ul>
    </div>
  )
};

export default Whos;
